import React from 'react';
import { Menu, MenuItem, IconButton, Tooltip } from '@mui/material';
import { NotificationStatus } from '../../../../../interfaces/Commons/Notifications/notificationStatuses';

interface FilterMenuProps{
    anchorElFilterMenu: HTMLElement | null;
    handleCloseFilterMenu: () => void;
    notificationStatuses: NotificationStatus[];
    filterNotificationsByStatus: (status: NotificationStatus) => void;
    setSelectedStatus: (value: React.SetStateAction<NotificationStatus | null>) => void
}

export const FilterMenu = ({
    anchorElFilterMenu,
    handleCloseFilterMenu,
    notificationStatuses,
    filterNotificationsByStatus,
    setSelectedStatus,
}: FilterMenuProps) => {
    return (
        <Menu
            id="filter-menu"
            anchorEl={anchorElFilterMenu}
            keepMounted
            open={Boolean(anchorElFilterMenu)}
            onClose={handleCloseFilterMenu}
        >
            {notificationStatuses.map((status, index) => (
                status.notification_status_name != 'Eliminado' &&
                <MenuItem key={index} onClick={() => {
                    filterNotificationsByStatus(status);
                    setSelectedStatus(status);
                    handleCloseFilterMenu();
                }}>
                    {status.notification_status_name}
                </MenuItem>
            ))}
        </Menu>
    );
};

export default FilterMenu;